// extracted by mini-css-extract-plugin
export default {"comment__sceleton":"CommentSceleton_comment__sceleton__BXlFX","shineForSkeleton-90w611qhf82":"CommentSceleton_shineForSkeleton-90w611qhf82__6DGwb"};